<template>
  <ol>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>1. Overview of Designer Journeys</p>
      <ol>
        <li>
          <div class='flex'>
            <span>1.1</span>
            <div>
              Designer Journeys.Com Pty Ltd (DESIGNER JOURNEYS) is an online platform that enables people
              <b>(TRAVELLERS and RETAIL TRAVEL AGENTS)</b>
              to create their ideal holiday by connecting them with Local Travel Agents at the Traveller's desired holiday destination
              <b>(LOCAL TRAVEL AGENTS)</b>
              who can create and deliver that trip
              <b>(TRIP)</b>.
              More specifically, Designer Journeys:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                allows the Traveller, or a Retail Travel Agent acting on behalf of that Traveller, to use the design tool within Designer Journeys to set out the Traveller's requirements for their holiday, including, for example, the destination, duration of the holiday, number of travelling companions and any activities that the Traveller would like to be included in their itinerary
                <b>(DESIGN)</b>;
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                sends the completed Design to Local Travel Agents who are able to deliver what is required;
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                enables the Local Travel Agents to use the Trip Plan Builder within Designer Journeys
                <b>(TRIP PLAN BUILDER)</b>
                to build a customised Trip that meets the requirements of the Design and which creates a proposed itinerary including the price for the proposed Trip
                <b>(the TRIP PLAN)</b>;
              </div>
            </li>
            <li class='flex'>
              <span>d.</span>
              <div>
                sends each Trip Plan prepared by the Local Travel Agent in response to a Design, to the Traveller or Retail Travel Agent;
              </div>
            </li>
            <li class='flex'>
              <span>e.</span>
              <div>
                enables the Traveller or Retail Travel Agent to review the Trip Plan and chat directly with the Local Travel Agent to refine the Trip Plan and/or ask questions about the Trip proposed;
              </div>
            </li>
            <li class='flex'>
              <span>f.</span>
              <div>
                enables Travellers or Retail Travel Agents to book Trips directly with the Local Travel Agents; and
              </div>
            </li>
            <li class='flex'>
              <span>g.</span>
              <div>
                enables Local Travel Agents and Travellers to submit reviews about their experiences.
              </div>
            </li>
          </ol>
        </li>
        <li>
          <div class='flex'>
            <span>1.2</span>
            <div>
              The Traveller or Retail Travel Agent is under no obligation to purchase any Trip.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>1.3</span>
            <div>
              The Traveller / Retail Travel Agent is not charged any fees for using the Design tool or for receiving Trip Plans provided in response to their Design. The Traveller / Retail Travel Agent only pays for the Trip Cost specified in a Trip Plan that is booked and confirmed in accordance with section 5 below.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>1.4</span>
            <div>
              Designer Journeys facilitates the connection of Travellers / Retail Travel Agents and Local Travel Agents online to arrange for the booking of Trips directly with each other. We are not:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                a party to any agreement that a Traveller / Retail Travel Agent and a Local Travel Agent enter into in respect of a Trip; or
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                a travel agent, nor do we provide any travel services or deliver any aspect of any Trip to any Traveller. Unless explicitly specified otherwise, our services are limited to facilitating the use and availability of Designer Journeys; and serving as the limited payment collection agent of each Local Travel Agent for the purpose of accepting and processing payments from Travellers / Retail Travel Agents on behalf of the Local Travel Agents, in accordance with sections 8 and 9 below. (both forming the
                <b>SERVICES</b>).
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                the originator or owner of Trip Plan content on the Designer Journeys website. All Trip Plan content is created by the Local Travel Agents and approved by them for posting to the Designer Journeys website.;
              </div>
            </li>
          </ol>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>2. Registration of user accounts</p>
      <ol>
        <li>
          <div class='flex'>
            <span>2.1</span>
            <div>
              You will need to register a user account in order to access Designer Journeys.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>2.2</span>
            <div>
              You must first register as a user of Designer Journeys and then register as either a Traveller, a Retail Travel Agent, or a Local Travel Agent. To submit Trip Plans and offer Trips to Travellers / Retail Travel Agent, you must be registered as a Local Travel Agent. To create a Design and book a Trip you must be registered as a Traveller or a Retail Travel Agent.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>2.3</span>
            <div>
              In order to register a user account, you must be a natural person who is at least 18 years of age.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>2.4</span>
            <div>
              In addition to the requirements of this section 2:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                if you are registering as a Local Travel Agent you must comply with the requirements of section 3 of these Terms;
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                if you are registering as a Traveller you must comply with the requirements of section 4 of these Terms; and
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                if you are registering as a Retail Travel Agent you must comply with the requirements of section 5 of these Terms.
              </div>
            </li>
          </ol>
        </li>
        <li>
          <div class='flex'>
            <span>2.5</span>
            <div>
              When registering a user account, you must provide accurate, complete and up-to-date information as requested on the registration page of Designer Journeys. It is your responsibility to inform us of any changes to that information. You may do this at any time by accessing your user account on Designer Journeys.
            </div>
          </div>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>3. Registration as a Local Travel Agent
      </p>
      <ol>
        <li>
          <div class='flex'>
            <span>3.1</span>
            <div>
              To be eligible to register as a Local Travel Agent you must:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                (a) specify the locations in which you intend to offer Trips, as well as details of the activities and other travel services you may offer to Travellers in a Trip Plan;
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                demonstrate, to our satisfaction (as determined by us in our sole discretion), that you have reasonable travel guide / operations experience in respect of the areas in which you propose to provide Trips;
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                provide a verifiable third party rating of your experience providing trips (for example a TripAdvisor rating);
              </div>
            </li>
            <li class='flex'>
              <span>d.</span>
              <div>
                hold and maintain any permits and licences required in your jurisdiction in order for you to provide the Trips to Travellers;
              </div>
            </li>
            <li class='flex'>
              <span>e.</span>
              <div>
                arrange and maintain appropriate insurance coverage to, at a minimum, cover your obligations as a Local Travel Agent and to insure against any loss or damage, however caused, suffered by a Traveller, yourself or any third party;
              </div>
            </li>
            <li class='flex'>
              <span>f.</span>
              <div>
                not have any conviction or pending charge for any type of criminal offence;
              </div>
            </li>
            <li class='flex'>
              <span>g.</span>
              <div>
                be accepted as a Local Travel Agent by us in our sole discretion and that we have no obligation to accept anyone as a Local Travel Agent.
              </div>
            </li>
          </ol>
        </li>
        <li>
          <div class='flex'>
            <span>3.2</span>
            <div>
              Before we accept your registration as a Local Travel Agent, we require you to be "vetted" by us and as such you agree to complete the necessary actions as determined by us from time to time, such as providing evidence of the licences and permits you hold and validating your prior travel industry experience.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>3.3</span>
            <div>
              As a Local Travel Agent, you represent and warrant that:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                you will provide the Trip using the standard of care, skill, diligence, prudence and foresight that would be reasonably expected of an experienced provider of trips and travel services;
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                all of the information you provide to us as part of the registration process is true, correct, complete and not misleading in any respect;
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                you will comply with all applicable laws, rules and regulations in respect of your use of Designer Journeys, the provision of each Trip Plan, and the delivery of Trips to Travellers;
              </div>
            </li>
            <li class='flex'>
                    <span>
                      d.
                    </span>
              <div>
                without limiting the warranty given in section 22.1, the possession or use by us or a Traveller or Retail Travel Agent of any Trip Plan will not infringe the intellectual property rights of any other person; and
              </div>
            </li>
            <li class='flex'>
              <span>e.</span>
              <div>
                you have all required permits and licences required to be held in your jurisdiction in order to deliver each Trip.
              </div>
            </li>
          </ol>
        </li>
        <li>
          <div class='flex'>
            <span>3.4</span>
            <div>
              As a Local Travel Agent, you acknowledge and agree that:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                we do not guarantee any minimum number of Trips will be purchased by Travellers;
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                you are solely responsible for all Trip Plans you provide to Travellers / Retail Travel Agents, and the content therein, and for honouring all Trips booked;
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                we are not a party to any agreement entered into between you and a Traveller / Retail Travel Agent in respect of a Trip and, whilst you may set out your own terms in such agreement, the terms of that agreement will not be inconsistent with these Terms;
              </div>
            </li>
            <li class='flex'>
              <span>d.</span>
              <div>
                you are solely responsible for performing your obligations under each agreement you have in place with a Traveller / Retail Travel Agent; and
              </div>
            </li>
            <li class='flex'>
              <span>e.</span>
              <div>
                our role is limited to acting as the authorised payment collection agent of the Local Travel Agent in accordance with sections 8 and 9 below.
              </div>
            </li>
          </ol>
        </li>
        <li>
          <div class='flex'>
            <span>3.5</span>
            <div>
              We require, wherever possible, that you obtain appropriate insurance to cover your obligations as a Local Travel Agent and provider of Trips in accordance with clause 3.1(e) of these Terms. We encourage you to review your insurance policy carefully, and please make sure that you are familiar with and understand any exclusions that apply to your insurance policy. In the event no local insurance policy is in place, or a policy which does not meet the requirements of Travellers / Retail Travel Agents , you must require travellers to provide evidence of having purchased their own travel insurance before commencing any trip.
            </div>
          </div>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>4. Registration as a Traveller
      </p>
      <ol>
        <li>
          <div class='flex'>
            <span>4.1</span>
            <div>
              To be eligible to register as a Traveller you must provide customary billing information such as name, billing address and credit card details (either to us or our third-party payment processor(s). How we handle your information is explained in
              <router-link to='/privacy-policy'>
                <small class='content-link fs-16'>privacy policy</small>
              </router-link>
              and our
              <router-link to='/privacy-policy'>
                <small class='content-link fs-16'>data protection policy</small>
              </router-link>
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>4.2</span>
            <div>Once you are registered as a Traveller, you can start using Designer Journeys to create your desired holiday and book Trips in accordance with these Terms.</div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>4.3</span>
            <div>We strongly recommend that you take out travel insurance at the time that you book a Trip. You acknowledge and agree that you are solely responsible for ensuring that you have an appropriate level of insurance to cover you in respect of your Trip.</div>
          </div>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>5. Registration as a Retail Travel Agent
      </p>
      <div>
        As a Retail Travel Agent, you acknowledge and agree that:
      </div>
      <ol>
        <li>
          <div class='flex'>
            <span>5.1</span>
            <div>prior to using Designer Journeys on behalf of a Traveller, you must procure that Traveller's agreement to be bound by and abide by these Terms; and</div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>5.2</span>
            <div>except where the context dictates otherwise, each reference in these Terms to 'Traveller' includes a reference to you as Retail Travel Agent.</div>
          </div>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>6. Booking a Trip
      </p>
      <ol>
        <li>
          <div class='flex'>
            <span>6.1</span>
            <div>
              Each Trip Plan will have a validity period during which a Traveller / Retail Travel Agent may book the Trip proposed in that Trip Plan
              (<b>BOOKING PERIOD</b>)
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>6.2</span>
            <div>If a Traveller / Retail Travel Agent books a Trip during the Booking Period, that booking will be automatically confirmed upon payment of the Deposit and any applicable Non-refundable Costs (as defined in sections 7 and 8 below) in accordance with section 8.</div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>6.3</span>
            <div>If a Traveller / Retail Travel Agent wishes to book a Trip, but the Booking Period has expired, the Traveller / Retail Travel Agent will need to ask the Local Travel Agent to reissue the Trip Plan. The Traveller / Retail Travel Agent acknowledges and agrees that the reissued Trip Plan may be subject to change (including as to cost) as a result of the lapse in time between the expiry of the original Booking Period and the reissuing of the Trip Plan.</div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>6.4</span>
            <div>Once you have paid the Deposit (and any applicable Non-refundable Costs) in accordance with section 8, we will send you a communication confirming the booking of the Trip.</div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>6.5</span>
            <div>Once a Trip is confirmed in accordance with section 6.4:</div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                you, as a Traveller / Retail Travel Agent, acknowledge and agree that we may provide your contact details to the Local Travel Agent who is providing the Trip; and
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                you, as a Local Travel Agent, acknowledge and agree that we may provide your contact details to the Traveller / Retail Travel Agent who has booked the Trip,
              </div>
            </li>
          </ol>
        </li>
        <li>
          <div class='flex'>
            <span>6.6</span>
            <div>If you are a Local Travel Agent, you agree that we may, in accordance with the cancellation terms set out sections 10 and 11,</div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                permit a Traveller to cancel a booking; and
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                refund to the Traveller that portion of the Trip Cost (as defined in section 7.2 below) as specified in section 11 below.
              </div>
            </li>
          </ol>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>7. Trip Cost
      </p>
      <ol>
        <li>
          <div class='flex'>
            <span>7.1</span>
            <div>
              The Local Travel Agent determines the total cost to deliver the Trip in their selected currency
              <b>(LOCAL TRAVEL AGENT COST)</b>
              , which includes any costs that are non-refundable and payable at the time of booking
              <b>(NON-REFUNDABLE COSTS)</b>
              and any applicable taxes that the Local Travel Agent is required by law to collect in their jurisdiction (including any sales taxes, value added taxes, goods and services taxes, transient occupancy taxes, tourist or other visitor taxes, accommodation or lodging taxes).
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>7.2</span>
            <div>
              A fee for using our Services, which is calculated as a percentage of the Local Travel Agent Cost (TRAVELLER FEE), will be automatically added to the Local Travel Agent Cost in the Trip Plan. The amount specified in the Trip Plan is the total cost payable by the Traveller or Retail Travel Agent for the Trip and comprises the Local Travel Agent Cost together with the Traveller Fee (Trip Cost).
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>7.3</span>
            <div>
              The Trip Cost will be payable by the Traveller or Retail Travel Agent. Payment in the Traveller's / Retail Travel Agent’s selected currency will be made at the exchange rate prevailing on the date of payment in the event the Trip cost is in a currency different from that the Traveller or Retail Travel Agent is paying with.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>7.4</span>
            <div>
              If you are a Traveller or Retail Travel Agent you are only responsible for the Trip Cost if you book a Trip and your Trip is confirmed by the Local Travel Agent in accordance with section 6.4.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>7.5</span>
            <div>
              We collect the Trip Cost payable by the Traveller / Retail Travel Agent and will initiate payment of the Local Travel Agent Cost (including the Non-refundable Costs) to the Local Travel Agent at the time and as further described in section 9.
            </div>
          </div>
        </li>
      </ol>

    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>8. Payment for Trip by the Traveller or Retail Travel Agent.
      </p>
      <ol>
        <li>
          <div class='flex'>
            <span>8.1</span>
            <div>
              If you are a Traveller or Retail Travel Agent, you acknowledge and agree that, notwithstanding the fact that we are not a party to the agreement between you and the Local Travel Agent, we act as the Local Travel Agent's payment collection agent for the limited purpose of accepting payments from you on behalf of the Local Travel Agent.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>8.2</span>
            <div>
              You agree to pay us the Trip Cost, including any Non-refundable Costs, in accordance with these Terms. You hereby authorise the collection of such amounts by charging the credit card or other eligible payment methods provided by you as part of your user registration, either directly by us or indirectly, via a third party online payment processor (such as PayPal).
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>8.3</span>
            <div>
              You understand and agree that we, on behalf of the Local Travel Agent, reserve the right, in our sole discretion, to obtain a pre-authorisation via your credit card for the Trip Cost or any part thereof.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>8.4</span>
            <div>
              You acknowledge that we cannot control any fees that may be charged to a Traveller or Retail Travel Agent by his or her bank or credit card company related to our collection of the Trip Cost, and we disclaim all liability in this regard.
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
                    <span>
                      a.
                    </span>
              <div>
                At the time you make a booking request for a Trip we will collect from you:
              </div>
            </li>
            <li class='flex'>
                    <span>
                      b.
                    </span>
              <div>
                a small fixed deposit
                (<b>DEPOSIT</b>); and
              </div>
            </li>
            <li class='flex mb-10'>
                    <span>
                      c.
                    </span>
              <div>
                the total amount of the Non-refundable Costs (if any).
              </div>
            </li>
            <div class='mb-4'>
              Sixty (60) days prior to the scheduled commencement of your Trip, we will collect the remaining amount of the Trip Cost from you.
            </div>
            <div>
              Once you have paid the Trip Cost to us in full, you have no obligation to pay the Local Travel Agent for your Trip.
            </div>
          </ol>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>9. Payment of Local Travel Agent Cost to Local Travel Agent
      </p>
      <ol>
        <li>
          <div class='flex'>
            <span>9.1</span>
            <div>
              Each Local Travel Agent appoints us as the Local Travel Agent's limited payment collection agent solely for the purpose of collecting the Local Travel Agent Cost directly from Travellers.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>9.2</span>
            <div>
              We will:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                pay the Local Travel Agent the Non-refundable Costs within 5 Business Days of receiving the Non-refundable Costs from the Traveller or Retail Travel Agent in our bank account in cleared funds; and
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                arrange for the balance of the Local Travel Agent Cost, being the total Local Travel Agent Cost received from a Traveller minus the Non-refundable Costs already paid to that Local Travel Agent in accordance with section 9.2 and any applicable taxes), to be transferred into the Local Travel Agent's nominated bank as soon as funds from the Traveller / Retail Travel Agent arrive in our bank account in cleared funds.
              </div>
            </li>
          </ol>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>10. Cancellation by the Traveller / Retail Travel Agent</p>
      <div>
        If you cancel some or all of your Trip after you have booked your Trip with a Local Travel Agent, the following shall apply;
      </div>
      <ol>
        <li>
          <ol class='pl-10'>
            <li class='flex'>
              <span>(a)</span>
              <div>
                if the cancellation is made after the payment of a Deposit but before the payment of any subsequent payments up to and including the full payment for your Trip, then the Deposit shall be forfeited by you; thereafter;
              </div>
            </li>
            <li class='flex mb-10'>
              <span>(b)</span>
              <div>
                if the cancellation is made after the payment of the Deposit, then the Local Travel Agent’s cancellation terms shall apply in respect of payments made, excluding the Deposit, save and accept that if there are no Local Travel Agent cancellation terms and conditions provided then the following shall apply:
              </div>
            </li>
            <ol class='pl-10'>
              <li class='flex'>
                <span>a.</span>
                <div>
                  All payments made in respect of the Trip are forfeited; and
                </div>
              </li>
              <li class='flex'>
                <span>b.</span>
                <div>
                  Designer Journey will use all reasonable endeavour to recover a proportion of payment made to the Local Travel Agent in respect of the Trip.
                </div>
              </li>
            </ol>
          </ol>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>11. Cancellation by the Local Travel Agent</p>
      <ol>
        <li>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                The Local Travel Agent may cancel your Trip at any time prior to the time it is due to commence. If the Local Travel Agent cancels your Trip (other than as a result of a Force Majeure Event), you will receive a full refund. Note;
              </div>
            </li>
            <li class='flex'>
                    <span>
                      b.
                    </span>
              <div>
                Where the Local Travel Agent has cancelled a Trip at any time prior to the time it is due to commence (other than as a result of a Force Majeure Event), the Local Travel Agent agrees to refund us any Non-refundable Costs we have paid to it in respect of that cancelled Trip within 2 Business Days of the cancellation of such Trip.
              </div>

            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                For the purposes of this clause,
                <b>
                  FORCE MAJEURE EVENT
                </b>
                means any fire, flood, earthquake or act of God and any other natural disaster, riot, act of terrorism, war, civil disorder, rebellion or revolution, strikes, lockouts and labour disputes, epidemics, quarantine restrictions, outbreak of disease or any travel restrictions or bans (including bans on non-essential travel) issued by the World Health Organisation or any governmental authority, or any other event beyond the reasonable control of the Local Travel Agent, but in each case only if and to the extent that the Local Travel Agent is without fault in causing the event.
              </div>
            </li>
          </ol>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>12. Goods and Services Tax</p>
      <ol>
        <li>
          <div class='flex'>
                  <span>
                    12.1
                  </span>
            <div>
              Words or expressions used in this section 12 which are defined in the A New Tax System (Goods and Services Tax Act 1999 (Cth) have the same meaning in these clauses.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
                  <span>
                    12.2
                  </span>
            <div>
              If we make a supply under or in connection with this Agreement on which GST is imposed, in whole or in part (not being a supply the consideration for which is specifically described as being GST inclusive) then:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                the consideration payable or to be provided for that supply under this Agreement but for the application of this section
                <b>(GST EXCLUSIVE CONSIDERATION)</b>
                is increased by, and you must also pay to us, an amount equal to the GST payable by you on that supply
                <b>(GST AMOUNT)</b>
                ; and
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                the GST Amount must be paid to us by you without set off, deduction or requirement for demand, at the same time as the GST exclusive consideration is payable or to be provided, subject to us giving you a tax invoice in respect of that taxable supply.
              </div>
            </li>
          </ol>
        </li>
        <li>
          <div class='flex'>
            <span>12.3</span>
            If a payment to a party under this Agreement is a reimbursement or indemnification, calculated by reference to a loss, cost or expense incurred by that party, then the payment will be reduced by the amount of any input tax credit to which that party is entitled for that loss, cost or expense.
          </div>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>13. Traveller / Retail Travel Agent Acknowledgements</p>
      <ol>
        <li>
          <div class='flex'>
            <span>13.1</span>
            <div>
              This section 13 applies if you are a Traveller or Retail Travel Agent.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
                  <span>
                    13.2
                  </span>
            <div>
              You acknowledge and agree that:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                we are not the provider of any Design, Trip Plan or Trip;
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                if you book a Trip, you will be taken to have contracted directly with the Local Travel Agent and we are not a party to that agreement;
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                you book a Trip at your own risk;
              </div>
            </li>
            <li class='flex'>
              <span>d.</span>
              <div>
                we do not endorse any Local Travel Agent, Trip Plan, Trip or any review submitted by any user;
              </div>
            </li>
            <li class='flex'>
                    <span>
                      e.
                    </span>
              <div>
                we do not make any attempt to verify the statements of users or reviews of Trips submitted by users;
              </div>
            </li>
            <li class='flex'>
              <span>f.</span>
              <div>
                whilst users are required by these Terms to provide accurate information, we are under no obligation to undertake additional checks to verify or check the identities or backgrounds of users and we do not confirm, endorse or make any representations about any user or the user’s purported identity or background nor the safety, quality, legality, timeliness or suitability of any Trip;
              </div>
            </li>
            <li class='flex'>
              <span>g.</span>
              <div>
                any references to a user being "vetted" (or similar language) only indicates that the user has completed a relevant verification process at that user's cost, and does not represent anything else;
              </div>
            </li>
            <li class='flex'>
              <span>h.</span>
              <div>
                any description of a user being "vetted" is not an endorsement, certification or guarantee by us about any user or Trip, including of the user’s identity and whether the user is trustworthy or suitable; and
              </div>
            </li>
            <li class='flex'>
              <span>i.</span>
              <div>
                we do not have any obligation to conduct background or police checks on any user, but may conduct such background or police checks in our sole discretion.
              </div>
            </li>
          </ol>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>14. Disclaimer</p>
      <ol>
        <li>
          <div class='flex'>
            <span>14.1</span>
            <div>
              Designer Journeys, and all content and/or services provided or made available through Designer Journeys, are made available to you on an 'as is' and 'as available' basis.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>14.2</span>
            <div>
              You acknowledge and agree that to the extent possible under the law, and subject to section 16, we make no representations, warranties or guarantees in relation to:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
                    <span>
                      a.
                    </span>
              <div>
                the content of any Design or Trip Plan;
              </div>
            </li>
            <li class='flex'>
                    <span>
                      b.
                    </span>
              <div>
                the Local Travel Agent's compliance with any agreement it has in place with Traveller / Retail Travel Agent;
              </div>
            </li>
            <li class='flex'>
                    <span>
                      c.
                    </span>
              <div>
                the availability, suitability, reliability, safety, value, quality or appropriateness of any Trip; or
              </div>
            </li>
            <li class='flex'>
                    <span>
                      d.
                    </span>
              <div>
                the availability, suitability, continuity, reliability, accuracy, currency or security of Designer Journeys.
              </div>
            </li>
          </ol>
        </li>
        <li>
          <div class='flex'>
                  <span>
                    14.3
                  </span>
            <div>
              You acknowledge and agree that to the extent possible under the law, and subject to section 16, we will not be liable:
            </div>
          </div>
          <ol>
            <li class='flex'>
              <span>a.</span>
              <div>
                for any loss, damage, cost or expense incurred by you in connection with your use of Designer Journeys (including any Trip);
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                for any act or omission of any Local Travel Agent, Traveller, Retail Travel Agent or other third party;
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                if Designer Journeys (or any content submitted to, provided on or made available through it) is incomplete, corrupted, inaccurate, outdated or incorrect, or if Designer Journeys (or any services provided or made available through it) are unavailable for any reason, including directly or indirectly as a result of:
                <ol class='pl-20'>
                  <li class='flex'>
                    <span>1.</span>
                    <div>
                      telecommunications unavailability, interruption, delay, bottleneck, failure or fault;
                    </div>
                  </li>
                  <li class='flex'>
                    <span>2.</span>
                    <div>
                      negligent, malicious or wilful acts or omissions of third parties (including our third party service providers);
                    </div>
                  </li>
                  <li class='flex'>
                    <span>3.</span>
                    <div>
                      maintenance or repairs carried out by us or any third party service provider in respect of any of the systems used in connection with the provision of Designer Journeys;
                    </div>
                  </li>
                  <li class='flex'>
                    <span>4.</span>
                    <div>
                      any events beyond our control; or
                    </div>
                  </li>
                  <li class='flex'>
                    <span>5.</span>
                    <div>
                      services provided by third parties ceasing or becoming unavailable.
                    </div>
                  </li>
                </ol>
              </div>
            </li>
          </ol>
        </li>
        <li>
          <div class='flex'>
                  <span>
                    14.4
                  </span>
            <div>
              You also acknowledge and agree that to the extent possible under the law, and subject to section 16, we do not represent, warrant or guarantee that Designer Journeys is free from computer viruses or any other defect or error which may affect your software or systems. You should protect your software and systems by installing and implementing your own security and system checks.
            </div>
          </div>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>15. Indemnity</p>
      <div>
        You indemnify us (and all our Related Bodies Corporate (as that term is defined in the
        <i>
          Corporations Act 2001 Cth
        </i>)
        , employees and officers) against all loss, actions, proceedings, cost and expenses (including legal fees), claims and damages
        <b>(DAMAGES) </b>
        arising directly or indirectly out of or in connection with:
      </div>
      <ol>
        <li>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                a breach by you of these Terms;
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                any negligent or fraudulent act, error or omission by you;
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                the use of your user account by you or any third party;
              </div>
            </li>
            <li class='flex'>
              <span>d.</span>
              <div>
                the publication or transmission of any information that you provide to us for inclusion in Designer Journeys (including any Damages sustained or incurred by us in connection with complaints or claims relating to any such information);
              </div>
            </li>
            <li class='flex'>
              <span>e.</span>
              <div>
                loss of or damage to any property or injury to or death of any person caused by any act or omission by you;
              </div>
            </li>
            <li class='flex'>
              <span>f.</span>
              <div>
                if you are a Retail Travel Agent:
                <ol class='pl-20'>
                  <li class='flex'>
                    <span>i.</span>
                    <div>
                      a failure by you to obtain the Traveller's agreement in accordance with section 5(a) of these Terms; or
                    </div>
                  </li>
                  <li class='flex'>
                    <span>ii.</span>
                    <div>
                      a breach by a Traveller (for whom you are acting as agent) of these Terms; or
                    </div>
                  </li>
                </ol>
              </div>
            </li>
            <li class='flex'>
              <span>g.</span>
              <div>
                any claim by a third party against us relating to:
                <ol class='pl-20'>
                  <li class='flex'>
                    <span>i.</span>
                    <div>
                      a Trip Plan or Trip;
                    </div>
                  </li>
                  <li class='flex'>
                    <span>ii.</span>
                    <div>
                      your use of Designer Journeys (or use by any person who accesses Designer Journeys using your user account); or
                    </div>
                  </li>
                  <li class='flex'>
                    <span>iii.</span>
                    <div>
                      any information that you provide to us via Designer Journeys.
                    </div>
                  </li>
                </ol>
              </div>
            </li>
          </ol>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>16. Consumer guarantees</p>
      <div>
        To the extent permitted by law, any conditions, warranties, guarantees, rights, remedies, liabilities and other terms implied or conferred by statute, custom or the general law that impose any liability or obligation on us are excluded under these Terms. However, if a supply under these Terms is a supply of goods or services to a consumer within the meaning of the Australian Consumer Law
        <i>
          (contained in Schedule 2 to the Competition and Consumer Act 2010
        </i>
        (Cth), as amended or replaced from time to time), nothing contained in these Terms excludes, restricts or modifies the application of any provision, the exercise of any right or remedy, or the imposition of any liability under the Australian Consumer Law, provided that, to the extent that the Australian Consumer Law permits us to limit our liability, then our liability is limited to:
      </div>
      <ol>
        <li>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                in the case of services, the cost of supplying the services again or payment of the cost of having the services supplied again; and
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                in the case of software or other goods, the cost of replacing the goods, supplying equivalent goods or having the goods repaired, or payment of the cost of replacing the goods, supplying equivalent goods or having the goods repaired, and except in the case of a major failure (as that term is defined in the Australian Consumer Law), we can elect as between the remedies set out in paragraphs (a) and (b) above.
              </div>
            </li>
          </ol>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>17. Exclusion of liability</p>
      <div>
        Subject to section 16, and to the extent permitted by law, we exclude liability for all direct, indirect or consequential liabilities, losses, damages, costs and expenses (including, without limitation, loss of revenue, loss of goodwill, downtime costs, loss of profit, loss of or damage to reputation, loss under or in relation to any other contract, loss of data, loss of use of data or loss of anticipated savings or benefits), whether arising in contract, tort (including negligence) or otherwise, suffered or incurred by any person:
      </div>
      <ol>
        <li>
          <ol class='pl-10'>
            <li class='flex'>
                    <span>
                      a.
                    </span>
              <div>
                in connection with or in any way relating to Designer Journeys or any content and/or services provided or made available through Designer Journeys, including:
                <ol class='pl-20'>
                  <li class='flex'>
                    <span>i.</span>
                    <div>
                      in connection with any Design, Trip Proposal or Trip;
                    </div>
                  </li>
                  <li class='flex'>
                    <span>ii.</span>
                    <div>
                      in connection with any disruption to or unavailability or failure of Designer Journeys or interference with or damage to computer systems or other electronic devices;
                    </div>
                  </li>
                  <li class='flex'>
                          <span>
                            iii.
                          </span>
                    <div>
                      in connection with errors, omissions or inaccuracies contained in any information published on or available via Designer Journeys;
                    </div>
                  </li>
                  <li class='flex'>
                          <span>
                            iv.
                          </span>
                    <div>
                      as a result of any fraudulent use, misuse or misappropriation of any user account; or
                    </div>
                  </li>
                  <li class='flex'>
                          <span>
                            v.
                          </span>
                    <div>
                      as a result of any act committed by another person in connection with your use of Designer Journeys or any content and/or services provided or made available through Designer Journeys;
                    </div>
                  </li>
                </ol>
              </div>
            </li>
            <li class='flex'>
                    <span>
                      b.
                    </span>
              <div>
                arising from any circumstance beyond our control; and
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                otherwise under or in connection with these Terms.
              </div>
            </li>
          </ol>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>18. Restrictions on use</p>
      <ol>
        <li>
          <div class='flex'>
            <span>18.1</span>
            <div>
              You agree to only use Designer Journeys in accordance with these Term and applicable laws. Without limiting the previous sentence you must not:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
                    <span>
                      a.
                    </span>
              <div>
                use Designer Journeys (or any content and/or services provided or made available through Designer Journeys) for any purpose other than as permitted by these Terms;
              </div>
            </li>
            <li class='flex'>
                    <span>
                      b.
                    </span>
              <div>
                remove or tamper with any copyright notices on Designer Journeys;
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                disassemble, decompile, reverse engineer, or create derivative works or functionally equivalent software from Designer Journeys (except to the extent permitted by Division 4A of Part III of the Copyright Act 1968 (Cth));
              </div>
            </li>
            <li class='flex'>
                    <span>
                      d.
                    </span>
              <div>
                copy or download, in a systematic manner, any text, graphics, information, designs, data or other content from Designer Journeys, or communicate or otherwise distribute such systematically obtained text, graphics, information, designs, data or other content; or
              </div>
            </li>
            <li class='flex'>
              <span>e</span>
              <div>
                incorporate Designer Journeys in any product to be made available commercially (unless we expressly agree otherwise with you).
              </div>
            </li>
          </ol>
        </li>
        <li>
          <div class='flex'>
            <span>18.2</span>
            <div>
              You must not, directly or indirectly, introduce or permit the introduction of, any virus, worm, trojan or other malicious code into Designer Journeys, or in any other manner whatsoever corrupt, degrade or disrupt Designer Journeys.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>18.3</span>
            <div>
              You must not (nor permit a third party to) upload, post or submit any data or information to or via Designer Journeys (or provide us with any data or information in connection with Designer Journeys), nor otherwise use Designer Journeys:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                to engage in any activity which breaches any law, infringes a third party’s rights, or in a manner which interferes with the rights of any other person;
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                to infringe our intellectual property rights (including our trade marks and copyright) or the intellectual property rights or any third party;
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                in any way that is defamatory, obscene, misleading or deceptive or otherwise illegal;
              </div>
            </li>

            <li class='flex'>
              <span>d.</span>
              <div>
                in any way that constitutes misuse, or resale or other commercial use, of Designer Journeys (or any content and/or services provided or made available through Designer Journeys); or
              </div>
            </li>
            <li class='flex'>
              <span>e.</span>
              <div>
                in a way that is regarded by the public or media as unacceptable or which brings our reputation into disrepute or which is otherwise prejudicial or detrimental to our reputation.
              </div>
            </li>
          </ol>
        </li>

      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>19. Links to other Sites
      </p>
      <div>
        We may, from time to time, publish links to other third party sites on Designer Journeys. These links are provided for your convenience only and by accessing these third party sites, you agree to any terms of access or use imposed by those sites. We do not endorse any material on third party sites and do not provide any warranty, or assume any responsibility regarding the quality, accuracy, source, merchantability, fitness for purpose or any other aspect of the material on those sites, nor do we warrant that material on other sites does not infringe the intellectual property rights of any other person.
      </div>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>20. Variation, suspension and termination </p>
      <ol>
        <li>
          <div class='flex'>
                  <span>
                    20.1
                  </span>
            <div>
              Without prejudice to any other rights or remedies that we may have against you under these Terms or at law, if you breach any provision of these Terms, we may, by giving you written notice, terminate these Terms and disable your access to Designer Journeys, without any liability to you (other than to pay any amounts owing to you in accordance with these Terms).
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
                  <span>
                    20.2
                  </span>
            <div>
              We may:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                change all or part of Designer Journeys (including the availability of any feature or content) or suspend access to Designer Journeys at any time for any reason, without having to give you notice;
              </div>
            </li>
            <li class='flex'>
                    <span>
                      b.
                    </span>
              <div>
                impose limits on certain features or restrict your access to all or part of Designer Journeys, without having to give you notice;
              </div>
            </li>
            <li class='flex'>
              <span>c.</span>
              <div>
                terminate your access to and use of Designer Journeys (including your user account) without cause by giving you 14 days prior written notice; and
              </div>
            </li>
            <li class='flex'>
              <span>d.</span>
              <div>
                edit, remove or alter any content provided by you in our sole discretion.
              </div>
            </li>
          </ol>
        </li>
        <li>
          <div class='flex'>
                  <span>
                    20.3
                  </span>
            <div>
              A notice given to you under these Terms may be sent to you by email.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
                  <span>
                    20.4
                  </span>
            <div>
              You may close your user account at any time by sending an email to <a href='mailto:info@designerjourneys.com'><small class='content-link fs-16'>info@designerjourneys.com</small></a>.
            </div>
          </div>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>21. System requirements</p>
      <div>
        In order to use Designer Journeys you must have any relevant hardware and software, and an internet data connection with location services activated. We cannot guarantee that Designer Journeys will operate correctly on all mobile devices.
      </div>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>22. Intellectual Property
      </p>
      <ol>
        <li>
          <div class='flex'>
            <span>22.1</span>
            <div>
              You grant us an irrevocable, perpetual, non-exclusive, worldwide, royalty-free, sub-licensable licence to use, reproduce, adapt, modify, communicate and publish all content that you submit to Designer Journeys (including Trip Plans). You warrant to us that you have the necessary rights to grant this licence.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>22.2</span>
            <div>
              Subject to section 22.1, and unless otherwise indicated, we (and/or our third party licensors) own the copyright and other intellectual property rights in the text, graphics, information, designs, data and other content on Designer Journeys. While you may browse or print the content for non-commercial, personal or internal business use, you must obtain our prior written permission if you would like to use, copy or reproduce any part of Designer Journeys for any other purpose.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>22.3</span>
            <div>
              All trade marks appearing on Designer Journeys belong to their respective owners. You may not use our trade marks in Australia or internationally without our prior written consent, except to legitimately identify our products or services.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>22.4</span>
            <div>
              Notwithstanding sections 22.2 and 22.3 and subject to your compliance with clause 22.5, if you are a Local Travel Agent we grant you a limited, non-exclusive, revocable, royalty free, non-sub-licensable licence to use Trip Plan Builder to build Trip Plans for your customers who are not registered as Travellers on Designer Journeys.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>22.5</span>
            <div>
              If you provide Trip Plans to customers who are not registered as Travellers / Retail Travel Agents, you:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                must comply with section 18;
              </div>
            </li>
            <li class='flex'>
              <span>b.</span>
              <div>
                must ensure that your customers are aware that we are not endorsing the Trip Plan or you as a Local Travel Agent;
              </div>
            </li>
            <li class='flex'>
                    <span>
                      c.
                    </span>
              <div>
                must not use our name or trade marks other than to the extent our name or trade mark is automatically included on the Trip Proposal as a result of your use of Trip Creator; and
              </div>
            </li>
            <li class='flex'>
              <span>d.</span>
              <div>
                will indemnify us (and all our subsidiaries, employees and officers) against all Damages arising directly or indirectly out of or in connection with a claim against us by any third party to whom you provide any such Trip Plan.
              </div>
            </li>
          </ol>
        </li>
        <li>
          <div class='flex'>
            <span>22.6</span>
            <div>
              We may, from time to time and in our sole discretion, give Local Travel Agents access to third party editing tools within Designer Journeys. If we do so, you acknowledge and agree that:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
                    <span>
                      a.
                    </span>
              <div>
                your use of such third party tools will, in addition to these Terms, be subject to the applicable third party licence agreement we have in place with the licensor of that third party tool and which we have provided to you; and
              </div>
            </li>
            <li class='flex'>
                    <span>
                      b.
                    </span>
              <div>
                if the third party tool enables you to edit or process video footage or images of a Trip (including Travellers on a Trip):
                <ol class='pl-20'>
                  <li class='flex'>
                          <span>
                            i.
                          </span>
                    <div>
                      notwithstanding clause 22.1, any video footage or images edited or processed using that third party tool captured by your use of the third party tool (Image Content) will be owned by Us and we grant you an irrevocable, perpetual, non-exclusive, worldwide, royalty-free, licence to use, reproduce, adapt, modify, communicate and publish the Image Content for the sole purpose of marketing yourself as a Local Travel Agent and the right to sub-license the Image Content to the Traveller identified in the Image Content for that Traveller to use, reproduce, modify, communicate and publish for their own personal use; and
                    </div>
                  </li>
                  <li class='flex'>
                          <span>
                            ii.
                          </span>
                    <div>
                      before you edit or process any Image Content using the third party tool:
                      <ol class='pl-10'>
                        <li class='flex'>
                          <span>A.</span>
                          <div>
                            you will inform the Traveller that:
                            <ol class='pl-20'>
                              <li class='flex'>
                                <span>I.</span>
                                <div>
                                  any such Image Content will be owned by us and may be used by us for any purpose; and
                                </div>
                              </li>
                              <li class='flex'>
                                <span>II.</span>
                                <div>
                                  you will be licensed to use the Image Content for the purpose of marketing yourself as a Local Travel Agent; and
                                </div>
                              </li>
                            </ol>
                          </div>
                        </li>
                        <li class='flex'>
                                <span>
                                  B.
                                </span>
                          <div>
                            you will be solely responsible for obtaining the consent of the Traveller in respect of their appearance in the Image Content and the use of the Image Content as contemplated by paragraph (A). You acknowledge and agree that the consent of the Traveller will not have been obtained unless you have first informed them as required under paragraph (A). You warrant that the consent of each Traveller appearing in the Image Content has been obtained in accordance with this clause 22.6.
                          </div>
                        </li>
                      </ol>
                    </div>
                  </li>
                </ol>
              </div>
            </li>
          </ol>
        </li>
      </ol>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>23. Comments and complaints
      </p>
      <div>
        If you are having difficulties accessing Designer Journeys or would like to lodge a query or complaint, please contact us at
        <a href='mailto:info@designerjourneys.com'><small class='content-link fs-16'>info@designerjourneys.com</small></a>. We take your feedback seriously and will promptly investigate and respond to all genuine complaints.
      </div>
    </li>
    <li class='pb-15'>
      <p class='fw-700 fs-28 lh-32 mb-33'>24. General
      </p>
      <ol>
        <li>
          <div class='flex'>
            <span>24.1</span>
            <div>
              We may change these Terms from time to time. If we reasonably consider that the change is likely to:
            </div>
          </div>
          <ol class='pl-10'>
            <li class='flex'>
              <span>a.</span>
              <div>
                benefit you or have a neutral or minor detrimental impact on you, we may change these Terms by making such changes immediately without notifying you except by publishing these Terms as amended on Designer Journeys; or
              </div>
            </li>
            <li class='flex mb-10'>
              <span>b.</span>
              <div>
                have a significant detrimental impact on you, we will make such changes to these Terms no sooner than 10 days after we have notified you of those changes on the home page of Designer Journeys and, in the case of changes related to fees, by email to the email address provided as part of your account registration.
              </div>
            </li>
          </ol>
          <div>
            If you do not accept a change made by us to these Terms, you must immediately cease using Designer Journeys and may close your user account by sending an email to
            <a href='mailto:info@designerjourneys.com'><small class='fs-16 content-link'>info@designerjourneys.com</small></a>.
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>24.2</span>
            <div>
              Local Travel Agents do not provide any services to us and are not our employees, contractors or agents. Except as provided in section 9.1, nothing in these Terms will constitute any trust, joint venture, partnership, agency or arrangement between us and any Local Travel Agent or between us and any Traveller.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>24.3</span>
            <div>
              You must not assign, sublicense or otherwise deal in any other way with any of your rights under these Terms.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>24.4</span>
            <div>
              If a provision of these Terms is invalid or unenforceable, it may be severed from these Terms and the remaining provisions of these Terms continue in force.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>24.5</span>
            <div>
              These Terms will be governed by and construed in accordance with the laws in force in Victoria, and you unconditionally submit to the jurisdiction of the courts of Victoria. Although Australian websites may be accessed outside of Australia, we make no representation that the content complies with the laws of any other country. If you access this website from outside Australia, you are solely responsible for ensuring compliance with your local laws and for any reliance on our website content.
            </div>
          </div>
        </li>
        <li>
          <div class='flex'>
            <span>24.6</span>
            <div>
              These Terms are the entire agreement between us on its subject matter and supersede any previous arrangements, agreements, representations, understandings or statements (whether verbal, in writing or in some other format).
            </div>
          </div>
        </li>
      </ol>
    </li>
  </ol>
</template>
<style scoped lang="scss">
ol {
  li {
    margin-top: 15px;
    span {
      font-weight: 700; // §8 (was 900 legacy black face)
      color: $link; // clause numbering (was legacy blue)
      margin-right: 12px;
      display: inline-block;
      font-size: 20px;
      line-height: 28px;
    }
    div {
      line-height: 24px;
      font-size: 16px; // §8 — body stays 16px even in legal fine print
    }
    .flex div {
      padding-top: 2px;
    }
  }
  &.popup-term {
    li {
      >p {
        font-size: 16px;
        font-weight: 700;
      }
      span {
        font-weight: 700;
        color: $link; // clause numbering (was legacy blue)
        margin-right: 12px;
        display: inline-block;
        font-size: 16px;
        line-height: 16px;
        padding-top: 6px;
      }
      div {
        line-height: 24px;
        font-size: 16px;
      }

    }
  }
}

// §9 text link — green, no resting underline; gold + underline on hover
.content-link {
  color: $link;
  text-decoration: none;
  transition: color $dur-fast $ease-out;
  @include focus-ring;
  &:hover {
    color: $link-strong; // v2 §7/§Link — darken (gold text on cream fails AA); underline stays
    text-decoration: underline;
  }
}
</style>
